export function runBackground(job: Promise<unknown>): undefined {
  job.then(
    () => undefined,
    () => undefined
  );
  return undefined;
}
